import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormHelperService } from '../../services/formHelper.service';
import { IOSHelperService } from '../../services/IOSHelper.service';
import { CoreLanguageService } from '../../services/language.service';
import { CoreLogService } from '../../services/log.service';
import { WebShopService } from '../../services/webShop.service';
import { OverlaySpinnerService } from '../overlayspinner/overlaySpiner.service';
import { WebShopMode } from '../../shared/contentTypes';
import { RouterHelperService } from '../../services/routerHelper.service';
import { Router } from '../../../../../node_modules/@angular/router';
import { InHouseOrderService } from '../../services/inHouseOrder.service';

@Component({
  selector: 'ya-qrcodeInput',
  templateUrl: './qrcodeInput.component.html',
  styleUrls: ['./qrcodeInput.component.scss'],
  providers: [FormHelperService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class QRCodeInputComponent implements OnInit {

  public tablecode: string = "";

  constructor(private _iosHelperService: IOSHelperService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _webShopService: WebShopService
    , private _inHouseOrderService: InHouseOrderService
    , private _formHelperService: FormHelperService
    , private _coreLanguageService: CoreLanguageService
    , private _coreLogService: CoreLogService
    , private _routerHelperService: RouterHelperService
    , private _router: Router
    , private _overlaySpinnerService: OverlaySpinnerService) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("QRCodeInputComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.PushChanges();
  }

  public setWebView(e) {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public getQRCodePalceHolder() {
    const me = this;
    return me._coreLanguageService.value("phQRCode_PlaceHolder");
  }

  /** achtung QrcodeScannerComponent auch beachten */
  public submitQRCodeData(): void {
    const me = this;
    const next_location = 0; // 0 > zum erzwingen der Warnung (da der QrCode sich unterscheidet, somit der Tisch)
    me._webShopService.openWarningResetBasketDialogIfNeed(next_location, WebShopMode.OrderToTable, async (agree) => {
      if (agree) {
        me._overlaySpinnerService.ShowLayoutSpinner();
        try {
          await me._inHouseOrderService.tryOpenTableCode(me.tablecode);
          //fixed webview position after keyboard hide in android
          document.getElementsByTagName("html")[0].style.height = "calc(var(--vh) * 101)";
          setTimeout(() => {
            document.getElementsByTagName("html")[0].style.height = "calc(var(--vh) * 100)";
          }, 100);
        } catch (error) {
          me._coreLogService.error("QRCodeInputComponent.submitQRCodeData", "inHouseOrderService.tryOpenTableCode(catch)", me.tablecode, error);
        }
        me._overlaySpinnerService.HideLayoutSpinner();
      } /* else do nothing */
    });
  }
/* prevents a blank character from being set in the input field */
  onInput() {
    const me = this;
    me.tablecode = me.tablecode.trim().replace(/\s+/g, '');
  }
  /**show all validation message by clicking on desabled button */
  public showErrorValidation(formGroup: FormGroup): void {
    const me = this;
    me._formHelperService.showValidationMsg(formGroup);
    me.PushChanges();
  }
}
